var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M4.07 6.148a4.08 4.08 0 1 1 8.16 0c0 1.696-.86 3.671-1.881 5.259-.505.785-1.033 1.45-1.48 1.91-.225.232-.42.402-.572.51-.07.049-.119.076-.148.09a1 1 0 0 1-.148-.09 4.3 4.3 0 0 1-.571-.51c-.448-.46-.976-1.125-1.48-1.91-1.02-1.588-1.88-3.563-1.88-5.259M8.15.968a5.18 5.18 0 0 0-5.18 5.18c0 2.008.991 4.2 2.054 5.853.537.836 1.11 1.56 1.616 2.083.253.26.5.48.728.641.199.14.48.307.781.307.3 0 .583-.166.782-.307.227-.16.474-.381.727-.641.507-.523 1.08-1.247 1.616-2.083 1.063-1.653 2.055-3.845 2.055-5.853A5.18 5.18 0 0 0 8.15.968m-1.303 5.18a1.302 1.302 0 1 1 2.604 0 1.302 1.302 0 0 1-2.604 0M8.15 3.746a2.402 2.402 0 1 0 0 4.804 2.402 2.402 0 0 0 0-4.804",
  clipRule: "evenodd"
})));
export { SvgMapMarker as ReactComponent };